<template>
  <v-card
    :wxid="$options.name"
    :class="[{ disabled: isTileDisabled, unfocused: isTileUnfocused }, targetStatusClass]"
    class="tile availability status-pictogram"
    tag="section"
    sf="1"
  >
    <grouped-tile-selector-menu :tile-index="tileIndex" />
    <div class="tile-inner">
      <h3 :title="$t('tiles.availability')" class="primary-title">
        {{ $t("tiles.availability") }}
        <v-icon v-if="!isTileAuthorized()">mdi-lock</v-icon>
      </h3>
      <h2 class="primary-value">{{ primaryValue }}</h2>
      <section class="status-details">
        <dl>
          <dt>{{ targetType }}</dt>
          <dd class="d-flex align-center">
            <v-icon class="mr-1">mdi-target</v-icon>
            {{ targetValue }}
          </dd>
        </dl>
        <div class="pictogram" />
      </section>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import GroupedTileSelectorMenu from "@/components/dashboard/tiles/GroupedTileSelectorMenu";
import TileBase from "@/components/dashboard/tiles/TileBase";
import Tiles from "@/components/Tiles";
import Helpers from "@/helpers";

export default {
  name: "TileAvailability",
  extends: TileBase,
  inheritAttrs: false,
  components: { GroupedTileSelectorMenu },
  computed: {
    ...mapGetters("dashboard", ["availability", "availabilityTarget"]),
    ...mapGetters("packages", ["activePuHasRequiredFeature"]),
    ...mapGetters("tiles", ["selectedTileIndex"]),
    isTileUnfocused() {
      return this.selectedTileIndex !== null && this.tileIndex !== this.selectedTileIndex;
    },
    isTileDisabled() {
      return !this.isTileAuthorized();
    },
    primaryValue() {
      return this.availability && this.isTileAuthorized() ? Helpers.round(this.availability, 1) + "%" : "—";
    },
    targetValue() {
      if (this.availabilityTarget) {
        return Helpers.round(this.availabilityTarget, 1) + "%";
      } else {
        return this.$t("common.nA");
      }
    },
    targetType() {
      return this.$t("dashboard.targetInfo.line");
    },
    targetStatusClass() {
      let statusClass;
      if (this.availabilityTarget && this.availability) {
        const value = this.availability - this.availabilityTarget;
        if (value >= 0) {
          statusClass = this.successCssClass;
        } else if (value >= -5) {
          statusClass = this.warningCssClass;
        } else {
          statusClass = this.errorCssClass;
        }
      }
      return statusClass;
    },
  },
  methods: {
    isTileAuthorized() {
      return this.activePuHasRequiredFeature(Tiles.availability.requiredFeature);
    },
  },
};
</script>
